import { useNavigate } from "react-router-dom";
import Cupones from "../../page/cupones/Cupones";
import { useContext, useEffect, useState } from "react";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { authContext } from "../../../../context/auth/AuthContext";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const CuponesController = () => {
  const navigate = useNavigate();
  const { user } = useContext(authContext);
  const { data } = user;

  const [loading, setLoading] = useState(false);
  const [cupones, setCupones] = useState(null);
  const [filter, setFilter] = useState({
    sort: 'id',
    ['filter[status]']: 'ACTIVO'
  });
  let controller;

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "añadir-cupon":
        {
          return navigate(`/dashboard/cupones/nuevo`);
        }
        break;
      case "editar-cupon":
        {
          return navigate(`/dashboard/cupones/${value}`);
        }
        break;
      case "status-cupon": {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("status", value.status);

          const response = await RestPrivateAntesala({
            url: `/cupones/${value.cupon.id}`,
            formData: formData,
            method: "POST",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
      } break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "":
        {
        }
        break;
    }
  };
  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!cupones) {
      let params = {
        ...filter,
      };
       fetch(setCupones, params, "/cupones");
    }
  }, []);

  return (
    <Cupones
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      data={cupones ?? { data: [], links: [] }}
      setData={setCupones}
      onChange={onChange}
      onClick={onClick}
      navigate={navigate}
      user={data}
    />
  );
};

export default CuponesController;
